/**
 * Tiny macOS-style window header. Three traffic lights on the left, an
 * optional centered "url pill" in the middle. Used at the top of the hero
 * illustration and the invoice preview pane to give those panels a polished
 * window vibe consistent with the design library.
 */

interface Props {
  title?: string;
  className?: string;
}

export function MacTitlebar({ title, className }: Props) {
  return (
    <div className={`titlebar${className ? ` ${className}` : ''}`}>
      <div className="lights" aria-hidden>
        <span className="btn-mac-traffic t-red"   />
        <span className="btn-mac-traffic t-amber" />
        <span className="btn-mac-traffic t-green" />
      </div>
      {title && (
        <div className="url">
          <span className="pill">{title}</span>
        </div>
      )}
      <div className="actions" aria-hidden />
    </div>
  );
}
